import type React from "react";
import styled from "styled-components";
import { useLanguage } from "../contexts/LanguageContext";

const ToggleContainer = styled.div<{ $variant?: "light" | "dark" }>`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const LanguageButton = styled.button<{
  $active: boolean;
  $variant?: "light" | "dark";
}>`
  background: ${(props) => {
    if (props.$variant === "light") {
      return props.$active ? "rgba(0, 0, 0, 0.1)" : "transparent";
    }
    return props.$active ? "rgba(255, 255, 255, 0.2)" : "transparent";
  }};
  border: 1px solid ${(props) => {
    if (props.$variant === "light") {
      return props.$active ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.2)";
    }
    return props.$active
      ? "rgba(255, 255, 255, 0.4)"
      : "rgba(255, 255, 255, 0.2)";
  }};
  color: ${(props) => (props.$variant === "light" ? "#000" : "#fff")};
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;

  &:hover {
    background: ${(props) => {
      if (props.$variant === "light") {
        return "rgba(0, 0, 0, 0.05)";
      }
      return "rgba(255, 255, 255, 0.15)";
    }};
    border-color: ${(props) => {
      if (props.$variant === "light") {
        return "rgba(0, 0, 0, 0.25)";
      }
      return "rgba(255, 255, 255, 0.3)";
    }};
  }
`;

interface LanguageToggleProps {
  variant?: "light" | "dark";
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({
  variant = "dark",
}) => {
  const { language, setLanguage } = useLanguage();

  return (
    <ToggleContainer $variant={variant}>
      <LanguageButton
        $active={language === "de"}
        onClick={() => setLanguage("de")}
        $variant={variant}
      >
        DE
      </LanguageButton>
      <LanguageButton
        $active={language === "en"}
        onClick={() => setLanguage("en")}
        $variant={variant}
      >
        EN
      </LanguageButton>
    </ToggleContainer>
  );
};
